import makeStyles from '@mui/styles/makeStyles';

const styles = makeStyles(() => ({
  cancelModalContainer: {
    width: "100%",
  },
  descriptionModalConfirm: {
    display: "flex",
    gap: "0.7rem",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    flexDirection: "column",
    "& span": {
      fontFamily: "Inter",
      fontStyle: "normal",
      fontWeight: "400",
      fontSize: "16px",
      lineHeight: "24px",
    },
    "& .error": {
      color: "#F04438",
      fontStyle: "italic",
    },
  },
}));

export default styles;
